import { Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ProductService } from '@suvo-bi-users';
import { FiltersChannel } from '../../../../filters/models/filters-channel.model';
import { IFiltersTileDefinition } from '../../../interfaces/tiles/definitions/filters-tile-definition.interface';
import { ITileComponent } from '../tile-component.interface';

@Component({
  standalone: false,
  selector: 'suvo-bi-filters-tile',
  templateUrl: './filters-tile.component.html',
  styleUrls: ['./filters-tile.component.scss'],
})
export class FiltersTileComponent implements ITileComponent, OnChanges {
  @Input() tileInstance: IFiltersTileDefinition;
  @Input() filtersChannel: FiltersChannel;

  autoApplyFilters = false;

  allowed = false;
  exportDisabled = false;

  private readonly productService = inject(ProductService);

  ngOnInit() {
    this.refreshState();
  }

  ngOnChanges(_changes: SimpleChanges) {
    this.refreshState();
  }

  private refreshState() {
    this.autoApplyFilters = !!this.tileInstance?.autoApplyFilters;
    this.allowed = false;
    this.exportDisabled = false;

    if (this.tileInstance.autoApplyFilters) {
      this.autoApplyFilters = true;
    }

    if (this.filtersChannel) {
      this.allowed = this.productService.isFeatureEnabled('FINDANDPAGINATE', [
        'DATASOURCE:' + this.filtersChannel.channelName,
      ]);

      this.exportDisabled = !this.productService.isFeatureEnabled('EXPORT', [
        'DATASOURCE:' + this.filtersChannel.channelName,
      ]);
    }
  }
}
